"use client"
import { gql, useQuery } from "@apollo/client"
import MoreLinksMain from "./MoreLinksMain"

const MORE_LINKS_QUERY = gql`
  query {
    metadata {
      id
      name
      title
      filter
    }
  }
`

export default function MoreLinks() {
  const { data, error } = useQuery(MORE_LINKS_QUERY)

  if (error) {
    return (
      <div className="flex flex-col gap-4">
        <h1 className="text-center text-white pt-4 text-xl font-gilroySemiBold">
          Other Links
        </h1>
        <span className="text-red-500 font-gilroyMedium">
          Failed to fetch links
        </span>
      </div>
    )
  }

  return (
    <div className="flex flex-col gap-4">
      <h1 className="text-center text-white pt-4 text-xl font-gilroySemiBold">
        Other Links
      </h1>

      <MoreLinksMain data={data} />
    </div>
  )
}
